/**
 * 跳转 App 下载页（hash 路由 `#/download`）
 * @param {import('vue-router').Router} [router]
 * @returns {void}
 */
export function navigateToDownloadPage(router) {
  if (router && typeof router.push === 'function') {
    router.push({ name: 'download' });
    return;
  }
  if (typeof window === 'undefined') return;
  const u = new URL(window.location.href);
  u.hash = '#/download';
  window.location.assign(u.toString());
}
